require('./externalTransferValuesSuccessScreen.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const { toFirstUppercase } = require('utilities/stringHelper');
const { formatWithoutRound } = require('utilities/currencyHelper');

// @constants
const {
    API_CENTER,
    API_ENTERPRISE_NUMBER,
} = require('constants/index');

class ExternalTransferValuesSuccessScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            waferIsExpanded: false
        }
        this.handleAcordionClick = this.handleAcordionClick.bind(this);
    }

    formatContractNumber(controlDigit, product, contractNumber) {
        if (!!contractNumber && !!product) {
            return `${API_ENTERPRISE_NUMBER} ${API_CENTER} ${controlDigit} ${product}${contractNumber}`;
        }
    }

    addSpacesBetweenAccountDigits(accountNumber) {
        if (!!accountNumber) {
            accountNumber = accountNumber.toString();
            const enterPriseNumber = accountNumber.substr(0, 4);
            const APICenter = accountNumber.substr(4, 4);
            const controlDigit = accountNumber.substr(8, 2);
            const productAndContractNumber = accountNumber.substr(10);
            return `${enterPriseNumber} ${APICenter} ${controlDigit} ${productAndContractNumber}`;
        }
    }

    buildDataTable() {
        const { immExternalTransferValues } = this.props;
        const immFirstStep = immExternalTransferValues.getIn(['steps', 0]);
        const originAccount = this.addSpacesBetweenAccountDigits(immFirstStep.get('contractNumber'));
        const bankName = immFirstStep.get('bankName') || '-';
        const destinationAccountObject = immFirstStep.get('destinationAccountObject');
        const associatedAccount = destinationAccountObject && destinationAccountObject.get('associatedAccount');
        const formattedAssociatedAccount = this.addSpacesBetweenAccountDigits(associatedAccount);
        const titular = destinationAccountObject && destinationAccountObject.get('firstTitular');
        const contractNumber = destinationAccountObject && destinationAccountObject.get('contactNumber');
        const productNumber = destinationAccountObject && destinationAccountObject.get('productNumber');
        const controlDigit = destinationAccountObject && destinationAccountObject.get('controlDigit');
        const accountName = destinationAccountObject && destinationAccountObject.get('walletAccountType');
        const accountAlias = destinationAccountObject && destinationAccountObject.get('associatedAccountAlias');
        const fullContractNumber = this.formatContractNumber(controlDigit, productNumber, contractNumber);
        const fileName = immFirstStep.getIn(['filesAttached', 0, 'name']) || '';
        const accountInfo = `${toFirstUppercase(accountName)} | ${fullContractNumber}`;
        const documentUploadError = immExternalTransferValues.get('documentUploadError');
        const fileNameClasses = classnames('transfer-success-screen__data-value', {
            'transfer-success-screen__data-value--error': documentUploadError
        });
        const documentUploadErrorText = documentUploadError && (
            <FormattedText
                className="transfer-success-screen__data-value transfer-success-screen__data-content-nospace"
                value="externalTransferValues-externalTransferValues_documentUploadErrorText"
            />
        );

        return (
            <div className="transfer-success-screen">
                <FormattedText
                    className="transfer-success-screen__data-heading"
                    value="externalTransferValues-externalTransferValues_transferDataTitle"
                />
                <div className="transfer-success-screen__table row">
                    <div className="col-xs-4">
                        <div className="transfer-success-screen__data-entity">
                            <FormattedText
                                className="transfer-success-screen__data-title"
                                value="externalTransferValues-externalTransferValues_transferDataOriginBank"
                            />
                            <div className="transfer-success-screen__data-value">{bankName}</div>
                        </div>
                        <div className="transfer-success-screen__data-entity">
                            <FormattedText
                                className="transfer-success-screen__data-title"
                                value="externalTransferValues-externalTransferValues_transferDataOriginIban"
                            />
                            <div className="transfer-success-screen__data-value">
                                <span className="transfer-success-screen__data-content-nospace">{originAccount}</span>
                                <FormattedText
                                    className="transfer-success-screen__data-content-nospace"
                                    value="externalTransferValues-externalTransferValues_transferAccountHolder"
                                    injectedStrings={[titular]}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-8">
                        <div className="transfer-success-screen__data-entity">
                            <FormattedText
                                className="transfer-success-screen__data-title"
                                value="externalTransferValues-externalTransferValues_transferDataDestination"
                            />
                            <div className="transfer-success-screen__data-value">
                                <span className="transfer-success-screen__data-content-nospace">
                                    {accountInfo}
                                </span>
                                <FormattedText
                                    className="transfer-success-screen__data-content-nospace transfer-success-screen__titular"
                                    value="externalTransferValues-externalTransferValues_transferAccountHolder"
                                    injectedStrings={[titular]}
                                />
                                <FormattedText
                                    className="transfer-success-screen__data-content-nospace"
                                    value="externalTransferValues-externalTransferValues_transferAccountName"
                                    injectedStrings={[accountAlias]}
                                />
                                <span className="transfer-success-screen__data-content-nospace">{formattedAssociatedAccount}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <FormattedText
                        className="transfer-success-screen__data-title"
                        value="externalTransferValues-externalTransferValues_bankStatementLabel"
                    />
                    <div className={fileNameClasses}>{fileName}</div>
                    {documentUploadErrorText}
                </div>
            </div>
        )
    }

    handleAcordionClick() {
        this.setState({
            waferIsExpanded: !this.state.waferIsExpanded
        });
    }

    createProductRow(product) {
        const productName = product.getIn(['product', 'name']);
        const isin = product.getIn(['product', 'isin']);
        const noOfProducts = product.get('noOfProducts');
        const productType = product.getIn(['product', 'productCategory']);
        const productTypeFormatted = productType && productType.toLowerCase();
        const firstCellClasses = `transfer-success-screen__products-table-cell transfer-success-screen__products-table-cell--${productTypeFormatted}`;
        const noOfProductsFormatted = formatWithoutRound(noOfProducts);

        return (
            <OKTableRow className="transfer-success-screen__products-table-row">
                <OKTableCell className={firstCellClasses}>
                    {productName}
                </OKTableCell>
                <OKTableCell className="transfer-success-screen__products-table-cell">
                    {isin}
                </OKTableCell>
                <OKTableCell className="transfer-success-screen__products-table-cell transfer-success-screen__products-table-cell--last">
                    {noOfProductsFormatted}
                </OKTableCell>
            </OKTableRow>
        );
    }

    createTotalProductsRow(totalProducts){
        const totalProductsFormatted = formatWithoutRound(totalProducts);
        return (
            <OKTableRow className="transfer-success-screen__products-table-final-row">
                <OKTableCell className="transfer-success-screen__products-table-cell" colSpan="2">
                    <FormattedText value="externalTransferValues-externalTransferValues_productsTableProductsTotal" />
                </OKTableCell>
                <OKTableCell className="transfer-success-screen__products-table-cell transfer-success-screen__products-table-cell--last transfer-success-screen__products-table-cell--total-product-cell">
                    {totalProductsFormatted}
                </OKTableCell>
            </OKTableRow>
        );
    }

    createProductsTable() {
        const { immExternalTransferValues } = this.props;
        const immSecondStep = immExternalTransferValues.getIn(['steps', 1]);
        const immSelectedProductsArray = immSecondStep.get('selectedProductsArray');
        let productsCount = 0;
        const productsRows = immSelectedProductsArray.map(product => {
            productsCount+= parseInt(product.get('noOfProducts'));
            return this.createProductRow(product)
        });
        const finalRow = this.createTotalProductsRow(productsCount);

        return (
            <OKTable>
                <thead>
                    <OKTableRow className="transfer-success-screen__products-table-header" asHeader>
                        <OKTableCell className="transfer-success-screen__products-table-cell" asHeader>
                            <FormattedText value="externalTransferValues-externalTransferValues_productsTableProductNameTitle" />
                        </OKTableCell>
                        <OKTableCell className="transfer-success-screen__products-table-cell" asHeader>
                            <FormattedText value="externalTransferValues-externalTransferValues_productsTableProductIsinTitle" />
                        </OKTableCell>
                        <OKTableCell className="transfer-success-screen__products-table-cell transfer-success-screen__products-table-cell--last" asHeader>
                            <FormattedText value="externalTransferValues-externalTransferValues_productsTableProductNumbersTitle" />
                        </OKTableCell>
                    </OKTableRow>
                </thead>
                <tbody>
                    {productsRows}
                    {finalRow}
                </tbody>
            </OKTable>
        );
    }

    createProductAccordian() {
        const { immExternalTransferValues } = this.props;
        const immSecondStep = immExternalTransferValues.getIn(['steps', 1]);
        const immSelectedProductsArray = immSecondStep.get('selectedProductsArray');
        const productsTable = this.createProductsTable();

        return (
            <Accordion
                id="external-products"
                isExpanded={this.state.waferIsExpanded}
                onClick={this.handleAcordionClick}
                hasLargeContent={false}
                customClassName="transfer-success-screen__products-accordian"
            >
                <AccordionHeader name="AccordionHeader">
                    <div className="transfer-success-screen__products-accordian-header">
                        <FormattedText
                            className="transfer-success-screen__products-accordian-header-title"
                            value="externalTransferValues-externalTransferValues_productsTableTitle"
                        />
                        <FormattedText
                            className="transfer-success-screen__products-accordian-header-title-count"
                            value="externalTransferValues-externalTransferValues_productsTableTitleCount"
                            injectedStrings={[immSelectedProductsArray.size]}
                        />
                    </div>
                </AccordionHeader>
                <AccordionBody name="AccordionBody">
                    <div className="transfer-success-screen__products-accordian-body">
                        {productsTable}
                    </div>
                </AccordionBody>
            </Accordion>
        );
    }

    render() {
        const dataTable = this.buildDataTable();
        const productsRows = this.createProductAccordian();

        return (
            <div className="transfer-success-screen__section">
                <div className="transfer-success-screen__container">
                    <div className="transfer-success-screen__data">
                        {dataTable}
                        {productsRows}
                    </div>
                </div>
            </div>
        );
    }
}

ExternalTransferValuesSuccessScreen.propTypes = {
    immExternalTransferValues: PropTypes.object.isRequired
};
module.exports = ExternalTransferValuesSuccessScreen;
